export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Head_Emissive.2b506299.tga";